import Skeleton from "react-loading-skeleton";


export default function LeaderBoardLoader() {
    return (
        <div className="mx-auto max-w-7xl px-5 lg:px-0">
            <div>
                <h3 className="text-lg font-bold">
                    <Skeleton className="" />
                </h3>
                <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
                    <thead>
                        <tr>
                            <th className="table-th !text-center"><Skeleton className="" /></th>
                            <th className="table-th !text-center"><Skeleton className="" /></th>
                            <th className="table-th !text-center"><Skeleton className="" /></th>
                            <th className="table-th !text-center"><Skeleton className="" /></th>
                            <th className="table-th !text-center"><Skeleton className="" /></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr className="">
                            <td className="table-td text-center font-bold"><Skeleton className="" /></td>
                            <td className="table-td text-center font-bold"><Skeleton className="" /></td>
                            <td className="table-td text-center font-bold"><Skeleton className="" /></td>
                            <td className="table-td text-center font-bold"><Skeleton className="" /></td>
                            <td className="table-td text-center font-bold"><Skeleton className="" /></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="my-8">
                <h3 className="text-lg font-bold"><Skeleton className="" /></h3>
                <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
                    <thead>
                        <tr className="border-b border-slate-600/50">
                            <th className="table-th !text-center"><Skeleton className="" /></th>
                            <th className="table-th !text-center"><Skeleton className="" /></th>
                            <th className="table-th !text-center"><Skeleton className="" /></th>
                            <th className="table-th !text-center"><Skeleton className="" /></th>
                            <th className="table-th !text-center"><Skeleton className="" /></th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr className="">
                            <td className="table-td text-center"><Skeleton className="" /></td>
                            <td className="table-td text-center"><Skeleton className="" /></td>
                            <td className="table-td text-center"><Skeleton className="" /></td>
                            <td className="table-td text-center"><Skeleton className="" /></td>
                            <td className="table-td text-center"><Skeleton className="" /></td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    )
};